// extracted by mini-css-extract-plugin
export default {"modalWrapper2":"Header_modalWrapper2__U36ts"};